const RO = {
  "AF": "Afganistan",
  "AX": "Insulele Åland",
  "AL": "Albania",
  "DZ": "Algeria",
  "AS": "Samoa Americane",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antarctica",
  "AG": "Antigua și Barbuda",
  "AR": "Argentina",
  "AM": "Armenia",
  "AW": "Aruba",
  "AU": "Australia",
  "AT": "Austria",
  "AZ": "Azerbaidjan",
  "BS": "Bahamas",
  "BH": "Bahrain",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BY": "Belarus",
  "BE": "Belgia",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermuda",
  "BT": "Bhutan",
  "BO": "Bolivia",
  "BA": "Bosnia și Herțegovina",
  "BW": "Botswana",
  "BV": "Insula Bouvet",
  "BR": "Brazilia",
  "IO": "Teritoriul britanic din Oceanul Indian",
  "BN": "Brunei Darussalam",
  "BG": "Bulgaria",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "KH": "Cambodgia",
  "CM": "Camerun",
  "CA": "Canada",
  "CV": "Capul Verde",
  "KY": "Insulele Cayman",
  "CF": "Republica Centrafricană",
  "TD": "Ciad",
  "CL": "Chile",
  "CN": "China",
  "CX": "Insula Crăciunului",
  "CC": "Insulele Cocos (Keeling)",
  "CO": "Columbia",
  "KM": "Comore",
  "CG": "Congo",
  "CD": "Congo, Republica Democrată a",
  "CK": "Insulele Cook",
  "CR": "Costa Rica",
  "CI": "Coasta de Fildeș",
  "HR": "Croația",
  "CU": "Cuba",
  "CY": "Cipru",
  "CZ": "Republica Cehă",
  "DK": "Danemarca",
  "DJ": "Djibouti",
  "DM": "Dominica",
  "DO": "Republica Dominicană",
  "CE": "Ecuador",
  "EG": "Egipt",
  "SV": "El Salvador",
  "GQ": "Guineea ecuatorială",
  "ER": "Eritreea",
  "EE": "Estonia",
  "ET": "Etiopia",
  "FK": "Insulele Falkland (Malvinas)",
  "FO": "Insulele Feroe",
  "FJ": "Fiji",
  "FI": "Finlanda",
  "FR": "Franța",
  "GF": "Guyana Franceză",
  "PF": "Polinezia Franceză",
  "TF": "Teritoriile franceze de sud",
  "GA": "Gabon",
  "GM": "Gambia",
  "GE": "Georgia",
  "DE": "Germania",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GR": "Grecia",
  "GL": "Groenlanda",
  "GD": "Grenada",
  "GP": "Guadelupa",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guineea",
  "GW": "Guineea-Bissau",
  "GY": "Guyana",
  "HT": "Haiti",
  "HM": "Insula Heard și Insulele Mcdonald",
  "VA": "Sfântul Scaun (statul Vaticanului)",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Ungaria",
  "IS": "Islanda",
  "IN": "India",
  "ID": "Indonezia",
  "IR": "Iran, Republica Islamică a",
  "IQ": "Irak",
  "IE": "Irlanda",
  "IM": "Insula Man",
  "IL": "Israel",
  "IT": "Italia",
  "JM": "Jamaica",
  "JP": "Japonia",
  "JE": "Jersey",
  "JO": "Iordania",
  "KZ": "Kazahstan",
  "KE": "Kenya",
  "KI": "Kiribati",
  "KP": "Coreea, Republica Populară Democrată din",
  "KR": "Coreea, Republica",
  "KW": "Kuweit",
  "KG": "Kârgâzstan",
  "LA": "Republica Democrată Populară Lao",
  "LV": "Letonia",
  "LB": "Liban",
  "LS": "Lesotho",
  "LR": "Liberia",
  "LY": "Jamahiriya arabă libiană",
  "LI": "Liechtenstein",
  "LT": "Lituania",
  "LU": "Luxemburg",
  "MO": "Macao",
  "MK": "Macedonia, Fosta Republică Iugoslavă a",
  "MG": "Madagascar",
  "MW": "Malawi",
  "MY": "Malaysia",
  "MV": "Maldive",
  "ML": "Mali",
  "MT": "Malta",
  "MH": "Insulele Marshall",
  "MQ": "Martinica",
  "MR": "Mauritania",
  "MU": "Mauritius",
  "YT": "Mayotte",
  "MX": "Mexic",
  "FM": "Micronezia, statele federate ale",
  "MD": "Moldova, Republica",
  "MC": "Monaco",
  "MN": "Mongolia",
  "MS": "Montserrat",
  "MA": "Maroc",
  "MZ": "Mozambic",
  "MM": "Myanmar",
  "NA": "Namibia",
  "NR": "Nauru",
  "NP": "Nepal",
  "NL": "Olanda",
  "AN": "Antilele Olandeze",
  "NC": "Noua Caledonie",
  "NZ": "Noua Zeelandă",
  "NI": "Nicaragua",
  "NE": "Niger",
  "NG": "Nigeria",
  "NU": "Niue",
  "NF": "Insula Norfolk",
  "MP": "Insulele Mariana de Nord",
  "NO": "Norvegia",
  "OM": "Oman",
  "PK": "Pakistan",
  "PW": "Palau",
  "PS": "Teritoriul palestinian, ocupat",
  "PA": "Panama",
  "PG": "Papua Noua Guinee",
  "PY": "Paraguay",
  "PE": "Peru",
  "PH": "Filipine",
  "PN": "Pitcairn",
  "PL": "Polonia",
  "PT": "Portugalia",
  "PR": "Puerto Rico",
  "QA": "Qatar",
  "RE": "Reuniune",
  "RO": "România",
  "RU": "Federația Rusă",
  "RW": "RWANDA",
  "SH": "Sfânta Elena",
  "KN": "Sfântul Kitts și Nevis",
  "LC": "Sfânta Lucia",
  "PM": "Saint Pierre și Miquelon",
  "VC": "Sfântul Vincent și Grenadine",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "Sao Tomé și Principe",
  "SA": "Arabia Saudită",
  "SN": "Senegal",
  "CS": "Serbia și Muntenegru",
  "SC": "Seychelles",
  "SL": "Sierra Leone",
  "SG": "Singapore",
  "SK": "Slovacia",
  "SI": "Slovenia",
  "SB": "Insulele Solomon",
  "SO": "Somalia",
  "ZA": "Africa de Sud",
  "GS": "Georgia de Sud și Insulele Sandwich de Sud",
  "ES": "Spania",
  "LK": "Sri Lanka",
  "SD": "Sudan",
  "SR": "Surinam",
  "SJ": "Svalbard și Jan Mayen",
  "SZ": "Swaziland",
  "SE": "Suedia",
  "CH": "Elveția",
  "SY": "Republica Arabă Siriană",
  "TW": "Taiwan, provincia Chinei",
  "TJ": "Tadjikistan",
  "TZ": "Tanzania, Republica Unită a",
  "TH": "Thailanda",
  "TL": "Timor-Leste",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad și Tobago",
  "TN": "Tunisia",
  "TR": "Turcia",
  "TM": "Turkmenistan",
  "TC": "Insulele Turks și Caicos",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ucraina",
  "AE": "Emiratele Arabe Unite",
  "GB": "Regatul Unit",
  "SUA": "Statele Unite",
  "UM": "Insulele periferice minore ale Statelor Unite",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Vietnam",
  "VG": "Insulele Virgine, britanice",
  "VI": "Insulele Virgine, S.U.A.",
  "WF": "Wallis și Futuna",
  "EH": "Sahara de Vest",
  "YE": "Yemen",
  "ZM": "Zambia",
  "ZW": "Zimbabwe",
};

export default RO;
